import { jsx as _jsx } from "react/jsx-runtime";
import { useCache, useResource } from "@rest-hooks/core";
import { LoginResource, StyleResource } from "@ploy-lib/rest-resources";
import { TenantProvider } from "@ploy-ui/tenants";
export const BrandTenantProvider = (props) => {
    const login = useCache(LoginResource.status(), {});
    const style = useResource(StyleResource.detail(), login && login.isAuthenticated
        ? {
            useAlternativeStyle: props.useAlternativeStyle ?? false,
            vendorId: login.vendor?.id,
            username: login.user?.username
        }
        : null) ?? {};
    const { theme, images } = style;
    return (_jsx(TenantProvider, { ...props, theme: {
            ...theme,
            ...props.theme,
            design: theme?.design?.length ? theme?.design : props.theme?.design
        }, images: { ...images, ...props.images }, dashboardImageCropMode: props.dashboardImageCropMode, locale: login?.locale }));
};
//# sourceMappingURL=BrandTenantProvider.js.map